import gql from "graphql-tag";

export const HAS_EXCEEDED_USER_LICENSE_ACCESS_LIMIT = gql`
    mutation hasExceededUserLicenseAccessLimit {
        hasExceededUserLicenseAccessLimit
    }
`;
